export default defineNuxtPlugin({
  name: "errorHandler",
  parallel: true,
  async setup(nuxtApp) {
    nuxtApp.hook("app:error", (error) => {
      console.error("Global error handler:", error);
      const reoload_error_list = [
        "error loading dynamically imported module",
        "Importing a module script failed",
        "Failed to fetch dynamically imported module",
      ];
      for (const message of reoload_error_list) {
        if (error.message.indexOf(message) > -1) {
          reloadNuxtApp({ persistState: true, ttl: 5000, path: "/" });
        }
      }
    });
    nuxtApp.hook("vue:error", (error) => {
      console.error("Vue error handler:", error);
    });
    nuxtApp.vueApp.config.errorHandler = (error, instance, info) => {
      console.error("VueApp error handler:", error, instance, info);
    };
  },
});
